/**
 * Local aonde são armazenadas todas as constantes com os nomes das mutations.
 */
export const SET_ALL = "setAll";
export const SET_CREDITOR = "setCreditor";
export const SET_LOADING = "setLoading";
export const SET_LOADING_ERROR = "setLoadingError";
export const SET_SAVING = "setSaving";
export const UPDATE_CREDITOR = "updateCreditor";
